import { serverNow } from "@/filters/DateAndTime";
import dayjs from "@/plugins/dayjsExtensions";

export interface Point {
  x: number;
  y: number;
}
export interface TimePoint {
  x: dayjs.Dayjs;
  y: number;
}

// returns all points in the range including the first one
// just out of range so the chart draws off the left side
export function pointsInRange(data: Array<Point>, rangeInMinutes: number) {
  const serverTime = serverNow();
  const dateInNumberForm = serverTime
    .subtract(rangeInMinutes, "minute")
    .toDate()
    .getTime();

  const datesWithinRange = data.filter(d => {
    return d.x > dateInNumberForm;
  });

  // If some points were filtered, include the first point that was not in range
  // so that the graph draws a line off the edge of the graph towards it
  if (datesWithinRange.length < data.length) {
    datesWithinRange.unshift(data[data.length - datesWithinRange.length - 1]);
  }
  return datesWithinRange;
}
